import React from 'react';
import { WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import Card from '../../../../components/Card';
import ReadmoreLabel from '../../../../components/ReadmoreLabel';

import './style.scss';

interface TaxonomyExpertiseCardProps {
  title: string;
  image: React.ReactNode;
  subtitle?: string | null;
  link?: string;
}

const TaxonomyExpertiseCard: React.FC<TaxonomyExpertiseCardProps> = ({
  title,
  image,
  subtitle,
  link,
}) => (
  <Card className="TaxonomyExpertiseCard">
    <div className="row">
      <div className="col-12 col-sm-5 col-lg-5 col-xl-4">
        <Card.Link href={link}>
          <Card.Image
            image={image}
          />
        </Card.Link>
      </div>
      <div className="col-12 col-sm-7 col-lg-6 offset-lg-1 col-xl-7 offset-xl-1">
        <Card.Link href={link}>
          <Card.Title title={title} />
        </Card.Link>

        <Card.Subtitle
          subtitle={(
            <>
              <WysiwygField className="u-truncate--3" html={subtitle} /><ReadmoreLabel />
            </>
          )}
        />
      </div>
    </div>
  </Card>
);

export default TaxonomyExpertiseCard;
